import dayjs from "@/helpers/dayjs";

export default {
  install(Vue) {
    Vue.prototype.$utcToLocal = (utcTime, format) =>
      dayjs(utcTime).format(format);

    Vue.prototype.$statusToKor = (status) => {
      if (status === "registered") return "주문검수중";
      if (status === "confirmed") return "기사모집중";
      if (status === "reviewed") return "기사모집중";
      if (status === "bid_end") return "배차대기중";
      if (status === "napoleon") return "자동배차중";
      if (status === "waiting") return "픽업대기중";
      if (status === "ongoing") return "수행중";
      if (status === "complete") return "배송완료";
      if (status === "canceling") return "취소요청";
      if (status === "cancel") return "취소완료";
    };
    Vue.prototype.$itemToKor = (item) => {
      if (item.hasOwnProperty("smallBox")) return "소박스";
      if (item.hasOwnProperty("bigBox")) return "대박스";
      if (item.hasOwnProperty("document")) return "서류";
      if (item.hasOwnProperty("etc")) return "기타";
    };
    Vue.prototype.$optionsToKor = (options) => {
      const option = [];
      if (options.indexOf("bike") === -1) option.push("차량");
      if (options.indexOf("bike") !== -1) option.push("오토바이가능");
      if (options.indexOf("express") !== -1) option.push("급송");
      if (options.indexOf("shuttle") !== -1) option.push("왕복");
      if (option.length === 0) return "없음";
      return option.toString();
    };
  }
};
